<template>
	<div class="cart">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<div class="cartItemsInfoWrapper">
			<div class="cartItemsWrapper">
				<div class="barcodeWrapper" v-if="activeOrder()">
					<input
						name="barcode"
						class="barcodeInput"
						placeholder="Enter Barcode (s: m:)"
						v-model="barcode"
						v-on:keyup.enter="submit"
						autofocus
						autocomplete="off"
					/>
				</div>

				<div class="backdate-wrapper">
					<div v-if="backdate == true">
						<b-field label="Date">
							<b-datepicker
								:date-formatter="dateFormatter"
								placeholder="Click to select..."
								v-model="orderDate"
								icon="calendar-today"
								:min-date="minDate"
								:max-date="maxDate"
							>
								<button class="button is-danger" @click="orderDate = null">
									<b-icon icon="close"></b-icon>
									<span>Clear</span>
								</button></b-datepicker
							>
						</b-field>
					</div>
					<div v-else></div>
				</div>

				<div v-bind:class="[openProductSuggestions ? 'customerSalesInfo' : 'hideSuggestions']">
					<div class="suggestionsWrapper">
						<div class="block">
							<b-radio
								v-model="selectedProduct"
								v-for="item of productSuggestions"
								name="salesperson"
								:key="item.barcode"
								:native-value="item.barcode"
								type="is-dark"
								>{{ item.name }}</b-radio
							>
						</div>

						<div class="suggestionButtons">
							<b-button type="is-dark" outlined @click="closeProductSuggestion('ok')">OK</b-button>
							<b-button type="is-danger" outlined @click="closeProductSuggestion('cancel')">Cancel</b-button>
						</div>
					</div>
				</div>

				<div v-bind:class="[openSuggestions ? 'customerSalesInfo' : 'hideSuggestions']">
					<div>
						<p>Suggestions</p>
					</div>

					<div class="suggestionsWrapper">
						<div class="block">
							<b-radio
								v-model="selectedSalesperson"
								v-for="item of suggestions"
								name="salesperson"
								:key="item._id"
								:native-value="item._id"
								type="is-dark"
								>{{ item.name }}</b-radio
							>
						</div>

						<div class="suggestionButtons">
							<button class="save-suggestion" outlined @click="closeSuggestion('ok')">OK</button>
							<button class="cancel-suggestion" outlined @click="closeSuggestion('cancel')">Cancel</button>
						</div>
					</div>
				</div>

				<div class="title-orderid">
					<div>
						<h3>Cart</h3>
					</div>
					<div class="order-id" v-if="order.alias">Order ID: {{ order.alias }} <br />Time: {{ convertTime(order.updatedAt) }}</div>
				</div>
				<div v-if="orderItems && orderItems.length > 0">
					<div v-for="(item, index) of orderItems" v-bind:key="item.itemId" class="cartItems">
						<div class="itemNumber">{{ getItemIndex(index) }}</div>
						<div class="itemDetailsWrapper">
							<div class="itemName">
								{{ item.product.name }}
								<!-- <p>
								{{ item.product.bd_code }} / Barcode:
								{{ item.product.barcode }}
							</p> -->
								<p v-if="!item.FOC">
									Price:
									<span v-if="item.product.price">{{ item.product.price.toLocaleString('en-GB') }}</span>
									<span
										v-if="item.product && item.product.packaging_selection && item.product.packaging_selection !== 'single_item'"
										class="packaging-selection-label"
									>
										&nbsp;({{ item.product.packaging_selection }})
									</span>
									<span class="item-discount" v-if="item.product.available_promotions">
										Discount:
										{{ displayPromotions(item.product.available_promotions) }}
									</span>
								</p>

								<p v-if="item.FOC">
									GIFT
								</p>

								<!-- <b-collapse :open="false" aria-id="contentIdForA11y1" class="apWrapper" v-if="debug && item.product.available_promotions && !item.FOC">
								<p slot="trigger" aria-controls="contentIdForA11y1" class="avaiable-discount" v-if="item.product.available_promotions">
									AP: {{ item.product.available_promotions.length }}
								</p>
								<div class="notification">
									<div class="content">
										<p class="title">Available Promotions</p>
										<div v-for="(item, index) of item.product.available_promotions" :key="index">
											<p>
												<span v-if="item.name">{{ item.name }}</span>

												<span v-if="item.promotion_group">/ Group Name: {{ item.promotion_group.name }}</span>

												<span v-if="item.condition.percentage">/ {{ item.condition.percentage }}%</span>
											</p>
										</div>
									</div>
								</div>
							</b-collapse> -->
							</div>

							<div class="itemQty">
								<div v-if="!item.FOC" class="itemQtyIcons" @click="updateQty(item.product.barcode, item.qty - 1)">-</div>
								<div v-else></div>
								<div v-if="displayAdditional(item)">
									<input
										name="qtyInput"
										class="qtyInput"
										type="number"
										v-bind:value="item.qty"
										v-on:change="updateQty(item.product.barcode, $event.target.value)"
									/>
								</div>
								<div v-else class="uneditQty">{{ item.qty }}</div>
								<div class="itemQtyIcons" @click="updateQty(item.product.barcode, item.qty + 1)" v-if="displayAdditional(item)">
									+
								</div>
							</div>
							<div class="itemPrice">
								<b-tooltip label="Special Discount" position="is-top" v-if="!item.FOC">
									<input
										name="specialDiscountInput"
										class="specialDiscountInput"
										type="number"
										v-bind:value="item.special_discount_percent"
										v-on:change="updateSpecialDiscount(item.product.barcode, $event.target.value, item.qty)"
										:disabled="disabledSpecialPromotion(item)"
									/>
									<span class="percent-sign">%</span>
								</b-tooltip>
							</div>
							<div class="itemTotalPrice">{{ item.total_price.toLocaleString('en-GB') }}</div>
							<div class="itemDelete">
								<span @click="deleteItem(item.product.barcode)" v-if="!item.FOC && order.pay_status == 0">
									<ios-trash-icon w="24px" h="24px" />
								</span>
							</div>
						</div>
					</div>
				</div>

				<h3 v-if="completeOrderPromotion.length > 0" class="order-foc">Gifts</h3>
				<div v-for="(item, index) of completeOrderPromotion" v-bind:key="index" class="cartItems">
					<div class="itemNumber">{{ getItemIndex(index) }}</div>
					<div class="itemDetailsWrapper">
						<div class="itemName">
							{{ item.name }}
							<p>
								<!-- {{ item.bd_code }} /  -->
								Barcode:
								{{ item.barcode }}
							</p>
						</div>
						<div class="itemQty">
							<div>
								<input name="qtyInput" class="qtyInput" type="number" :value="item.qty" disabled />
							</div>
						</div>
						<div class="itemPrice"></div>
						<div class="itemTotalPrice">0</div>
						<div class="itemDelete"></div>
					</div>
				</div>

				<div class="order-available-promotions" v-if="order && order.available_promotions && order.available_promotions.length > 0">
					Order Promos: {{ displayAvailablePromos() }}
				</div>
			</div>

			<div class="cartInfoContainer">
				<CartInfo :order="order" :key="sessionCount" />
			</div>
		</div>

		<b-modal :active.sync="isProductPromotionActive" :can-cancel="canCancelModal">
			<div class="orderSelectionWrapper">
				<h3>Please select 1 item</h3>

				<div class="barcodeWrapper">
					<input
						name="barcode"
						class="barcodeInput"
						placeholder="Enter Barcode"
						v-model="productPromotionBarcode"
						v-on:keyup.enter="productPromotionSubmit"
						autofocus
						autocomplete="off"
					/>
				</div>

				<div class="list">
					<div class="productPromotionList header">
						<div class="label">
							NAME
						</div>
						<div class="label">
							BD CODE
						</div>
						<div class="label">
							BARCODE
						</div>
					</div>
					<div v-for="(product, index) of productPromotionSelections" v-bind:key="index" class="productPromotionList">
						<div>
							{{ product.name }}
						</div>
						<div>
							{{ product.bd_code }}
						</div>
						<div>
							{{ product.barcode }}
						</div>
					</div>
				</div>

				<div class="checkoutWrapper">
					<div @click="cancelProductPromotion" class="cancelButton">Cancel</div>
					<div></div>
					<div></div>
				</div>
			</div>
		</b-modal>

		<b-modal :active.sync="isOrderPromotionActive" :can-cancel="canCancelModal">
			<div class="orderSelectionWrapper">
				<div v-for="(overall, index) in orderPromotionsAmount" :key="index" class="order-promo">
					<h3>
						{{ overall.promo_name }}
						<span v-if="overall.type !== 'discount_order_buy_two_get_one'"> Amount: {{ overall.total_amount.toLocaleString('en-GB') }} </span>
						<span v-else>Qty: {{ overall.repeatable }}</span>
					</h3>

					<div v-for="(items, promotion_index) in overall.promotions" :key="promotion_index">
						<div class="orderPromotionsDivider">
							<div>
								<div v-for="(product, product_index) in items.products" :key="product_index">
									<div
										:class="disabledPromotion(overall.type, overall.total_amount, items.target, overall.repeatable)"
										@click="addOrderPromotion(product, promotion_index, overall.promo_code, items.target, items.type, overall.repeatable)"
										class="promo-buttons"
									>
										+ {{ product.name }} ({{ product.barcode }})
									</div>
								</div>
							</div>

							<div>
								<div v-for="(selected_item, selected_index) in items.selected" :key="selected_index" class="selectedPromotion">
									<div class="selectedPromotionDivider">
										<span>{{ selected_item.name }}</span>

										<span
											@click="removeOrderPromotion(overall.type, selected_index, promotion_index, overall.promo_code, items.target)"
											class="selectedPromotionDelete"
										>
											<ios-close-icon w="48px" h="48px" />
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="checkoutWrapper">
					<div @click="cancelOrderPromotion" class="cancelButton">Cancel</div>
					<div></div>
					<div @click="saveOrderPromotion" class="checkoutButton">Checkout</div>
				</div>
			</div>
		</b-modal>

		<!-- Packaging Selection Modal -->
		<b-modal :active.sync="isPackagingSelectionActive" :can-cancel="false">
			<div class="orderSelectionWrapper">
				<h3>Select Packaging Type</h3>
				<p class="packaging-product-name" v-if="pendingProductData">{{ pendingProductData.name }}</p>

				<div class="packaging-options">
					<div
						v-for="(option, index) in packageSelections"
						:key="index"
						class="packaging-option"
						:class="{ selected: selectedPackaging === option.type }"
						@click="selectPackaging(option)"
					>
						<div class="packaging-type">{{ option.label }}</div>
						<div class="packaging-price">{{ option.price.toLocaleString('en-GB') }}</div>
						<div class="packaging-details" v-if="option.details">{{ option.details }}</div>
					</div>
				</div>

				<div class="checkoutWrapper">
					<div @click="cancelPackagingSelection" class="cancelButton">Cancel</div>
					<div></div>
					<div @click="confirmPackagingSelection" class="checkoutButton" :class="{ disabled: !selectedPackaging }">Confirm</div>
				</div>
			</div>
		</b-modal>

		<div id="printing" v-if="order.items">
			<img class="logo" v-if="this.$store.state.logo == 'bd'" v-bind:src="require('../assets/bdlogo.png')" />
			<img class="tbs-logo" v-if="this.$store.state.logo == 'tbs'" v-bind:src="require('../assets/tbs-logo.jpg')" />
			<img class="nrm-logo" v-if="this.$store.state.logo == 'nrm'" v-bind:src="require('../assets/nrm-logo.png')" />

			<div>{{ this.branchName }}</div>
			<div>{{ this.branchPhoneNumber }}</div>
			<div class="receiptInfo">
				<div v-if="order.alias">{{ order.alias }}</div>
				<div v-if="order.updatedAt">{{ convertTime(order.updatedAt) }}</div>
			</div>

			<div class="receiptInfo">
				<div v-if="order.salesperson">Sales: <br />{{ order.salesperson.name }}</div>
				<div v-if="customer !== null">
					Customer: <br />
					{{ customer.card_number }}
				</div>
			</div>
			<div class="header">
				<div>Qty</div>
				<div>Product</div>
				<div>Price</div>
			</div>
			<div v-for="item of orderItems" v-bind:key="item.itemId" class="receiptItems">
				<div>{{ item.qty }}</div>
				<div>
					{{ item.product.name }} @ {{ item.product.price }}
					<span v-if="item.product && item.product.packaging_selection && item.product.packaging_selection !== 'single_item'">
						({{ item.product.packaging_selection }})
					</span>
					<span v-if="!item.FOC">{{ displayPromotions(item.product.available_promotions, true) }}</span>
					<span v-if="item.special_discount_percent > 0">({{ item.special_discount_percent }} %)</span>
				</div>
				<div class="price">{{ item.total_price.toLocaleString('en-GB') }}</div>
			</div>

			<div v-for="(item, index) of completeOrderPromotion" v-bind:key="index" class="receiptItems">
				<div>{{ item.qty }}</div>
				<div>{{ item.name }} @ GIFT</div>
				<div class="price">0</div>
			</div>

			<div v-for="(promotion, index) of orderPromotion" v-bind:key="index">
				<div v-for="(product, index) of promotion.products" v-bind:key="index" class="receiptItems">
					<div>1</div>
					<div>{{ product.name }} @ GIFT</div>
					<div class="price">0</div>
				</div>
			</div>

			<p>- - - - - - - - - -</p>

			<div v-if="order.coupons && order.coupons.length > 0">
				<p>Coupons</p>
				<div v-for="(item, index) of order.coupons" v-bind:key="index" class="receiptInfo">
					<div>{{ item.brand.name }}</div>
					<div class="price">{{ item.amount }}</div>
				</div>
			</div>

			<div class="receiptInfo" v-if="calculateSave.toLocaleString('en-GB') > 0">
				<div>Save</div>
				<div class="price" v-if="order.total_price">{{ calculateSave.toLocaleString('en-GB') }}</div>
			</div>

			<div class="receiptInfo">
				<div>Total</div>
				<div class="price" v-if="order.total_price">{{ order.total_price.toLocaleString('en-GB') }}</div>
			</div>

			<div class="receiptInfo" v-if="order.pay_amount">
				<div>Cash</div>
				<div class="price" v-if="order.pay_amount">{{ order.pay_amount.toLocaleString('en-GB') }}</div>
			</div>

			<div class="receiptInfo" v-if="order.pay_amount">
				<div>Change</div>
				<div class="price" v-if="order.pay_amount">{{ calculateChange(order.pay_amount, order.total_price) }}</div>
			</div>

			<div class="receiptInfo">
				<div>Items Quantity</div>
				<div class="price">{{ totalQty }}</div>
			</div>

			<div class="receipt-payment-method">
				<div class="label">Paid by</div>
				<div>
					<div class="payment-method">
						<div>{{ receiptPaymentMethod() }}</div>
					</div>
					<!-- <div v-for="(paymentmethod, index) of order.payment_method" v-bind:key="index" class="payment-method">
						<div v-if="paymentmethod == 1" class="active">Cash</div>
						<div v-if="paymentmethod == 2" class="active">Card</div>
						<div v-if="paymentmethod == 3" class="active">Points</div>
						<div v-if="paymentmethod == 4" class="active">Coupons</div>
					</div> -->
				</div>
			</div>
			<p>Thank you!</p>
		</div>
	</div>
</template>

<script>
import CartInfo from '@/components/CartInfo.vue'

export default {
	name: 'Cart',

	data: function() {
		const cssText = `
      #printing {
  width: 230px;
  height: auto;
  text-align: center;
  margin: auto;
  font-size: 10px;
  font-family: monospace;
}

#printing .page-break-test {
	page-break-after: always;
}

#printing .logo {
  margin: 20px 0;
  width: 200px;
}

#printing .nrm-logo {
  margin-top: 20px;
  width: 200px;
}

#printing .tbs-logo {
  margin: 20px 0;
  width: 100px;
}

#printing .receiptInfo {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 10px 0;
}

#printing .receiptItems {
  text-align: left;
  display: grid;
  grid-template-columns: 30px 1fr 70px;
  margin-bottom: 10px;
}

#printing .receiptItems .price,
#printing .receiptInfo .price {
  text-align: right;
}

#printing .orderSelectionWrapper {
  background-color: #fff;
  padding: 10px;
}

#printing .orderPromotionsDivider {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 20px;
  padding: 10px;
}

#printing .orderPromotionCheckIcon {
  color: #6ba257;
}

#printing .checkoutWrapper {
  display: grid;
  grid-template-columns: 150px 1fr 150px;
  grid-gap: 20px;
}

#printing .orderPromotionList {
	background-color: #f2f2f2;
	padding: 20px;
	border-radius: 10px;
	margin-bottom: 20px;
}

#printing .orderPromotionList h3 {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 10px;
}

#printing .orderPromotionProduct {
  margin-bottom: 10px;
  cursor: pointer;
}

#printing .header {
  text-align: center;
  display: grid;
  grid-template-columns: 30px 1fr 70px;
  margin: 20px 0 10px 0;
}

#printing .receipt-payment-method {
  display: grid;
  grid-template-columns: 81px 1fr;
}

#printing .receipt-payment-method .label {
	font-weight: normal;
	font-size: 10px;
}

#printing .payment-method .active {
  height: 25px;
  width: 50px;
	color: #000;
	border: 1px solid #000;
  border-radius: 5px;
  text-align: center;
  margin-right: 10px;
  padding-top: 5px;
  float: left;
}
    `

		return {
			debug: this.$config.debug,
			sessionCount: 0,
			isOrderPromotionActive: false, // To display order promotion modal
			orderPromotionSelections: [], // To display list of promotion selections
			orderPromotion: [], // When cashier select order promotion item
			completeOrderPromotion: [], // Load completed order FOC items for display
			canCancelModal: false, // Disable modal cancellation
			productPromotionSelections: [], // List of buy 1 get 1 choices
			productPromotion: [], // Temp choosen buy 1 get 1 product
			isProductPromotionActive: false, // For product FOC modal
			orderItems: [], // Complete list of order items including FOC products
			FOCrepeatList: [],
			productPromotionBarcode: null, // To enter product promotion barcode at popup
			// For packaging selection
			isPackagingSelectionActive: false, // To display packaging selection modal
			packageSelections: [], // Available packaging options
			selectedPackaging: null, // Selected packaging option
			pendingProductData: null, // Store product data while selecting packaging
			branchName: null, // Branch name to set from API
			branchPhoneNumber: null, // Get branch phone number from API
			totalQty: 0, // Total order quantity including foc and gifts
			isLoading: false,
			customer: null, // To store customer data from VueX

			// For order promotion
			orderPromotions: {},
			orderPromotionsAmount: {}, // To store addtional brand_total, available
			orderDate: null, // For backdate
			minDate: new Date(new Date().setDate(new Date().getDate() - 340)),
			maxDate: new Date(new Date().setDate(new Date().getDate() - 1)),

			// Print Loop
			printLoop: 0,

			barcode: null,
			pay_amount: null,
			memberId: null,
			paymentType: [1],
			orderDesc: null,
			cartDetails: {},
			items: [],
			selectedSalesperson: null,
			// salespersonName: null,
			suggestions: [],
			openSuggestions: false,
			openProductSuggestions: false,
			productSuggestions: [],
			selectedProduct: null,
			order: {},
			backdate: false,
			cssText: cssText
		}
	},

	components: {
		CartInfo
	},

	mounted: async function() {
		await this.previousOrder()

		// If there is barcode copied
		if (this.$store.state.copyBarcode) {
			this.barcode = this.$store.state.copyBarcode
			this.$store.dispatch('set_copy_barcode', null)
		}

		// Check and set backdate
		if (this.$route && this.$route.name === 'backdate') {
			this.backdate = true
		} else {
			this.backdate = false
		}

		await this.getBranchInfo()

		// For Shortcuts
		// this._keyListener = function(e) {
		// 	if (e.key === 'F12' && e.ctrlKey) {
		// 		// this.checkout()
		// 		console.log('here')
		// 	}
		// }
	},
	computed: {
		calculateSave() {
			var total = this.order.no_promotion_total_price - this.order.total_price
			if (this.order.coupons.length > 0) {
				this.order.coupons.map(coupon => {
					total = total - coupon.amount
				})

				return total
			} else {
				return total
			}
		}
	},
	watch: {
		$route: function() {
			if (this.$route.name === 'backdate') {
				this.backdate = true

				if (this.order && this.order._id) {
					// If backdate is enabled and check the order create date to make sure it isn't current order
					if (this.$moment(this.order.createdAt).format('DD/MM/YYYY') == this.$moment().format('DD/MM/YYYY')) {
						this.cleanOrder()
					}
				}
			} else {
				this.backdate = false
			}
		},

		'$store.state.orderId': function() {
			this.previousOrder()
		},

		'$store.state.customer': function() {
			this.customer = this.$store.state.customer
		},

		order: async function() {
			// For displaying all the items including order FOC items
			if (this.order.promotions && this.order.promotions.length > 0) {
				this.getCompleteOrderPromotion()
			}

			if (this.order.customer) {
				let data = {
					id: this.order.customer
				}

				const apiSearchMember = await this.$api.getMember({ data })

				if (apiSearchMember) {
					// Save customer to vuex for information
					this.$store.dispatch('set_customer', apiSearchMember.data)
				}
			}

			if (this.order._id) {
				// Reset repeat list
				this.FOCrepeatList = []
				this.setOrderItems()

				// To get total quantity to display the receipt
				this.getTotalQty()

				// Check backdate
				if (this.$route.name && this.$route.name === 'backdate') {
					// If backdate is enabled and check the order create date to make sure it isn't current order
					if (this.$moment(this.order.createdAt).format('DD/MM/YYYY') == this.$moment().format('DD/MM/YYYY')) {
						this.cleanOrder()
					}
				}
			}
		}
	},

	methods: {
		displayAvailablePromos: function() {
			if (this.order && this.order.available_promotions && this.order.available_promotions.length > 0) {
				let orderPromo = []
				this.order.available_promotions.map(available_promotion => {
					if (available_promotion.promotion_group) {
						orderPromo.push(available_promotion.promotion_group.name)
					}
				})

				return orderPromo.join(', ')
			}
		},

		// Calculate change amount for receipt
		calculateChange: function(paidAmount = 0, total = 0) {
			let change = paidAmount - total
			return change > 0 ? change : 0
		},

		// Get brach info
		getBranchInfo: async function() {
			// Get data from info api
			const apiInfo = await this.$api.branchInfo()

			if (apiInfo !== undefined) {
				// Assign data
				let data = apiInfo.data['static-values'].configs.shops.entity

				// Assign branch name. Branch name is required
				this.branchName = data.name

				if (data.mobile_phone) {
					this.branchPhoneNumber = data.mobile_phone
				} else {
					this.branchPhoneNumber = this.$config.brandPhone
				}
			} else {
				// If error, set default values
				this.branchName = this.$config.branchName
				this.branchPhoneNumber = this.$config.brandPhone
			}
		},

		// For receipt payment method
		receiptPaymentMethod: function() {
			if (this.order.payment_method) {
				let methodArr = []

				this.order.payment_method.map(payment_method => {
					switch (payment_method) {
						case 2:
							methodArr.push('Card')
							break
						case 3:
							methodArr.push('Points')
							break
						case 4:
							methodArr.push('Coupons')
							break
						default:
							methodArr.push('Cash')
					}
				})

				return methodArr.join(' / ')
			} else {
				return ''
			}
		},

		// Check if product has packaging options (only for medicines with no price)
		hasPackagingOptions: function(product) {
			return (
				product &&
				(!product.price || product.price === 0) && // Only check packaging if product price is null or 0
				product.packaging &&
				((product.packaging.box && product.packaging.box.price) ||
					(product.packaging.card && product.packaging.card.price) ||
					(product.packaging.pill && product.packaging.pill.price))
			)
		},

		// Get available packaging options for a product
		getPackagingOptions: function(product) {
			const options = []

			if (product.packaging) {
				// Box packaging
				if (product.packaging.box && product.packaging.box.price) {
					const details = product.packaging.box.cards ? `${product.packaging.box.cards} cards` : ''
					options.push({
						type: 'box',
						label: 'Box',
						price: product.packaging.box.price,
						details: details
					})
				}

				// Card packaging
				if (product.packaging.card && product.packaging.card.price) {
					const details = product.packaging.card.pills ? `${product.packaging.card.pills} pills` : ''
					options.push({
						type: 'card',
						label: 'Card',
						price: product.packaging.card.price,
						details: details
					})
				}

				// Individual pill
				if (product.packaging.pill && product.packaging.pill.price) {
					options.push({
						type: 'pill',
						label: 'Individual Pill',
						price: product.packaging.pill.price,
						details: ''
					})
				}
			}

			return options
		},

		// Show packaging selection modal
		showPackagingSelection: function(productData, item, qtyToUpdate, promotions) {
			this.pendingProductData = {
				...productData,
				item: item,
				qtyToUpdate: qtyToUpdate,
				promotions: promotions
			}
			this.packageSelections = this.getPackagingOptions(productData)
			this.selectedPackaging = null
			this.isPackagingSelectionActive = true
		},

		// Select packaging option
		selectPackaging: function(option) {
			this.selectedPackaging = option.type
		},

		// Cancel packaging selection
		cancelPackagingSelection: function() {
			this.isPackagingSelectionActive = false
			this.selectedPackaging = null
			this.pendingProductData = null
			this.packageSelections = []
			this.barcode = null
		},

		// Confirm packaging selection and proceed with order
		confirmPackagingSelection: async function() {
			if (!this.selectedPackaging) {
				this.$buefy.toast.open({
					message: 'Please select a packaging option',
					type: 'is-warning',
					position: 'is-top'
				})
				return
			}

			const selectedOption = this.packageSelections.find(option => option.type === this.selectedPackaging)
			const productData = this.pendingProductData

			// Create a copy of product data and set the price to the selected packaging price
			const modifiedProductData = { ...productData }
			modifiedProductData.price = selectedOption.price
			modifiedProductData.packaging_selection = this.selectedPackaging

			console.log('Selected packaging:', this.selectedPackaging, 'Price:', selectedOption.price)

			// Close the modal
			this.isPackagingSelectionActive = false

			// Proceed with the order update
			await this.addProductToOrder(modifiedProductData, productData.item, productData.qtyToUpdate, productData.promotions)

			// Clean up
			this.selectedPackaging = null
			this.pendingProductData = null
			this.packageSelections = []
			this.barcode = null
		},

		// Add product to order (extracted from submit function)
		addProductToOrder: async function(productData, item, qtyToUpdate, promotions) {
			let data

			// Create the base item data
			const itemData = {
				barcode: productData.barcode,
				qty: qtyToUpdate
			}

			// If the product has a selected packaging price, include it
			if (productData.price) {
				itemData.price = productData.price
			}

			// Add packaging type information
			if (productData.packaging_selection) {
				itemData.packaging_selection = productData.packaging_selection
			} else if (productData.price && productData.price > 0) {
				// For products with existing price (non-medicine), mark as single item
				itemData.packaging_selection = 'single_item'
			}

			console.log('API call data:', itemData)

			if (!promotions) {
				data = {
					id: this.$store.state.orderId,
					populate_order: ['salesperson', 'coupons.brand'],
					items: [
						{
							action: 'add',
							data: itemData
						}
					]
				}
			} else {
				// Add promotions to the item data
				itemData.promotions = [{ id: promotions }]

				data = {
					id: this.$store.state.orderId,
					populate_order: ['salesperson', 'coupons.brand'],
					items: [
						{
							action: 'add',
							data: itemData
						}
					]
				}
			}

			const apiUpdateOrder = await this.$api.orderUpdate({ data })
			this.order = apiUpdateOrder.data
		},

		// To get total qty to display at receipt
		getTotalQty: function() {
			// Reset total quantity
			this.totalQty = 0

			let order = this.order

			order.items.map(product => {
				this.totalQty += product.qty

				if (product.promotions && product.promotions.length > 0) {
					product.promotions.map(promotion => {
						// Make sure this promotion is buy 1 get 1
						if (
							promotion.type == 'discount_product_buy_and_get_foc_from_list' ||
							promotion.type == 'discount_product_buy_one_get_one_and_percentage'
						) {
							if (promotion.options && promotion.options.products.length > 0) {
								this.totalQty += promotion.options.products.length
							}
						}
					})
				}
			})

			// For order FOC items to add in total qty
			if (order.promotions && order.promotions.length > 0) {
				order.promotions.map(promotion => {
					if (promotion.options && promotion.options.products.length > 0) {
						this.totalQty += promotion.options.products.length
					}
				})
			}
		},

		getTotalQtyFinal: function(order = null) {
			// Reset total quantity
			this.totalQty = 0

			order.items.map(product => {
				this.totalQty += product.qty

				if (product.promotions && product.promotions.length > 0) {
					product.promotions.map(promotion => {
						// Make sure this promotion is buy 1 get 1
						if (
							promotion.type == 'discount_product_buy_and_get_foc_from_list' ||
							promotion.type == 'discount_product_buy_one_get_one_and_percentage'
						) {
							if (promotion.options && promotion.options.products.length > 0) {
								this.totalQty += promotion.options.products.length
							}
						}
					})
				}
			})

			// For order FOC items to add in total qty
			if (order.promotions && order.promotions.length > 0) {
				order.promotions.map(promotion => {
					if (promotion.options && promotion.options.products.length > 0) {
						this.totalQty += promotion.options.products.length
					}
				})
			}
		},

		// Get active order or not
		activeOrder: function() {
			let pay_status = this.order.pay_status

			if (pay_status == 1 || pay_status == 2) {
				return false
			} else {
				return true
			}
		},

		// Get buy 1 get 1 items
		displayAdditional: function(item) {
			if (item.FOC) {
				// Hide unwanted
				return false
			} else if (item.promotions && item.promotions.length > 0 && item.promotions[0].type == 'discount_product_buy_and_get_foc_from_list') {
				// Hide unwanted
				return false
			} else if (item.promotions && item.promotions.length > 0 && item.promotions[0].type == 'discount_product_buy_one_get_one_and_percentage') {
				// Hide unwanted
				return false
			} else {
				// Display all
				return true
			}
		},

		// Combine products including FOC and buy1 get1 products
		setOrderItems: async function() {
			this.orderItems = []

			// Loop all the items in cart
			await Promise.all(
				this.order.items.map(async product => {
					// Reset foc repeat list for next product
					this.FOCrepeatList = []

					// Set general items to items
					this.orderItems.push(product)

					// For buy 1 get 1 FOC items
					if (product.promotions.length > 0) {
						await Promise.all(
							product.promotions.map(async promotion => {
								if (
									(promotion.type == 'discount_product_buy_and_get_foc_from_list' ||
										promotion.type == 'discount_product_buy_one_get_one_and_percentage') &&
									promotion.options
								) {
									await Promise.all(
										promotion.options.products.map(async product => {
											// Find repeat FOC products
											var findRepeat = this.FOCrepeatList.find(item => {
												return item == product
											})

											// If not repeat
											if (!findRepeat) {
												this.FOCrepeatList.push(product)

												let data = {
													id: product
												}

												const apiGetProductDetail = await this.getProductDetail(data)

												if (apiGetProductDetail !== undefined) {
													let counts = {}
													// Count how many repeat items
													promotion.options.products.forEach(function(x) {
														counts[x] = (counts[x] || 0) + 1
													})

													// Set price to zero for free gifts
													apiGetProductDetail.data.price = 0
													// orderItems has its own standard. Match those!
													const newProduct = {}
													newProduct.product = apiGetProductDetail.data
													newProduct.total_price = 0
													// newProduct.qty = 1;
													newProduct.qty = counts[product]
													newProduct.FOC = true

													this.orderItems.push(newProduct)
												}
											}
										})
									)
								}
							})
						)
					}
				})
			)
		},

		// Get complete FOC products to display
		getCompleteOrderPromotion: async function(newData = undefined) {
			let orderFOC = {}
			this.completeOrderPromotion = []

			// let promotions = this.order.promotions

			let promotions = newData ? newData.promotions : this.order.promotions

			for (const promotion in promotions) {
				if (promotions[promotion].options) {
					for (const foc_product in promotions[promotion].options.products) {
						// Assign product
						let product = promotions[promotion].options.products[foc_product]
						var data = {
							id: product
						}

						const apiGetProductDetail = await this.getProductDetail(data)

						// Add the qty if foc product already existed
						if (orderFOC[product]) {
							orderFOC[product].qty += 1
						} else {
							orderFOC[product] = {
								name: apiGetProductDetail.data.name,
								barcode: apiGetProductDetail.data.barcode,
								qty: 1
							}
						}
					}
				}
			}

			for (const item in orderFOC) {
				this.completeOrderPromotion.push(orderFOC[item])
			}
		},

		// To display chosen promotion FOC items when checking out
		getOrderPromotion: function(item) {
			return this.orderPromotion.filter(promotion => {
				return promotion.promotionId == item.promotionId
			})
		},

		// When cashier clicked on buy 1 get 1 product suggestion
		productPromotionSubmit: async function() {
			// console.log('loading')
			// this.isLoading = true
			const product = this.productPromotionSelections.find(product => {
				return this.productPromotionBarcode == product.barcode
			})

			var data = {
				id: this.$store.state.orderId,
				populate_order: ['salesperson', 'coupons.brand'],
				items: [
					{
						action: 'update',
						data: {
							barcode: product.mainProductBarcode,
							qty: product.qty
						}
					}
				]
			}

			if (product.orderItem == undefined) {
				data.items[0].data.promotions = [
					{
						id: product.promotionId,
						options: {
							products: [product._id]
						}
					}
				]
			} else {
				// Copy promotion items from old items
				data.items[0].data.promotions = [
					{
						id: product.orderItem.promotions[0]._id,
						options: product.orderItem.promotions[0].options
					}
				]

				if (data.items[0].data.promotions[0].options) {
					// Add a new one
					data.items[0].data.promotions[0].options.products.push(product._id)
				}
			}

			// Update order ID Quantity
			const apiUpdatePromotion = await this.$api.orderUpdate({ data })

			this.isLoading = false

			if (apiUpdatePromotion !== undefined) {
				this.order = apiUpdatePromotion.data
				this.isProductPromotionActive = false
				this.productPromotionBarcode = null
			}
		},

		// When cashier clicked on promotion FOC
		promotionClicked: function(promotionId, product, repeat) {
			var result = this.orderPromotion.find(promotion => {
				return promotion.promotionId == promotionId
			})

			const getSamePromotion = this.orderPromotionSelections.find(loopPromotion => {
				// console.log(product);

				return loopPromotion.promotion_group_code == product.promotion_group_code
			})

			if (getSamePromotion) {
				// console.log('we found same promotion');
			}

			let addProduct = []

			if (result) {
				this.orderPromotion.map((promotion, index) => {
					if (promotion.promotionId == promotionId) {
						// Copy previous product and push new one
						addProduct = promotion.products
						addProduct.push(product)

						// If product is more than repeat, remove the first one
						if (addProduct.length > repeat) {
							addProduct.shift()
						}

						// Get ready for new object
						const data = {
							promotionId,
							products: addProduct
						}

						// Remove promotion from orderPromotion to add new one
						this.orderPromotion.splice(index, 1)

						// Add new into push
						this.orderPromotion.push(data)
					}
				})
			} else {
				// If this promotion isn't in the object yet, add new
				addProduct.push(product)
				// Get ready for new object
				const data = {
					promotionId,
					products: addProduct
				}
				// Push new order promotion
				this.orderPromotion.push(data)
			}

			// console.log(this.orderPromotion);
		},

		// Display set promotion details
		displayPromotions: function(promotion, receipt = false) {
			if (promotion !== undefined) {
				// Brand % discount && For price point % discount
				if (promotion[0].type == 'discount_product_percentage_by_brands' || promotion[0].type == 'discount_product_percentage') {
					return receipt ? '(' + promotion[0].condition.percentage + '%' + ')' : promotion[0].condition.percentage + '%'
				}

				// For Buy 1 Get 1
				if (promotion[0].type == 'discount_product_buy_and_get_foc_from_list') {
					return 'Free/Discount Items'
				}

				// For Buy 1 Get 1 + percentage
				if (promotion[0].type == 'discount_product_buy_one_get_one_and_percentage') {
					return 'Free Item + Percentage ' + promotion[0].condition.percentage + '%'
				}

				// For price point amount discount
				if (promotion[0].type == 'discount_product_price') {
					return receipt ? '(-' + promotion[0].condition.price + ')' : '-' + promotion[0].condition.price
				}
			}
		},

		// Add cash pay amount
		addPayAmount: async function(customerPaidAmount) {
			// this.isLoading = true
			var data = {
				id: this.$store.state.orderId,
				populate_order: ['salesperson', 'coupons.brand'],
				pay_amount: customerPaidAmount
			}

			// If payment method is blank, add cash payment as default
			if (this.order.payment_method.length == 0) {
				data.payment_method = [1]
			}

			var apiAddPayAmount = await this.$api.orderUpdate({
				data
			})

			if (apiAddPayAmount) {
				this.order = apiAddPayAmount.data
			}
			this.isLoading = false
		},

		// Add cash pay amount
		addOnlineSales: async function(brand) {
			// this.isLoading = true
			var data = {
				id: this.$store.state.orderId,
				populate_order: ['salesperson', 'coupons.brand'],
				online_sales: brand
			}

			// If payment method is blank, add cash payment as default
			if (this.order.payment_method.length == 0) {
				data.payment_method = [1]
			}

			var apiResult = await this.$api.orderUpdate({
				data
			})

			if (apiResult) {
				this.order = apiResult.data
			}
			this.isLoading = false
		},

		// Update coupons
		updateCoupon: async function(value) {
			// this.isLoading = true
			var coupons = []

			value.map(coupon => {
				coupons.push({ brand: coupon.brand, amount: coupon.amount })

				// return newData;
			})

			var data = {
				id: this.$store.state.orderId,
				populate_order: ['salesperson', 'coupons.brand'],
				payment_method: this.order.payment_method,
				coupons
			}

			var apiUpdateCoupon = await this.$api.orderUpdate({
				data
			})

			if (apiUpdateCoupon) {
				this.order = apiUpdateCoupon.data
			}
			this.isLoading = false
		},

		previousOrder: async function() {
			// If there are last order in session, get it
			if (this.$store.state.orderId !== null) {
				this.isLoading = true
				// Get order details
				var orderDetails = await this.$api.orderDetails(this.$store.state.orderId)

				// Push order details into state
				if (orderDetails !== undefined) {
					this.order = orderDetails.data

					this.$buefy.toast.open({
						duration: 500,
						message: 'Order Loaded!',
						type: 'is-success',
						position: 'is-top'
					})
				} else {
					// If order id is invalid, delete from session
					// console.log('found nothing! and creating new!');
					this.$store.dispatch('set_order_id', null)
				}
				this.isLoading = false
			} else {
				this.order = {}
			}
		},

		// Generate new order
		newOrder: async function() {
			this.$store.dispatch('set_order_id', null)
			this.$store.dispatch('set_customer', null)
			this.orderPromotionSelections = []
			this.orderPromotion = []
			this.completeOrderPromotion = []
			this.orderItems = []
		},

		// Convert time for receipt
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		},

		print: function() {
			this.$printd.print(document.getElementById('printing'), [this.cssText])
		},

		// Order Description
		changeOrderDesc: async function(value) {
			var newDesc = value == '' ? null : value

			var data = {
				id: this.$store.state.orderId,
				populate_order: ['salesperson', 'coupons.brand'],
				description: newDesc
			}

			var updateDesc = await this.$api.orderUpdate({
				data
			})

			this.order = updateDesc.data
		},

		// Update pay_amount to use when order is checkout
		updatePayAmount: function(amount) {
			this.pay_amount = amount
		},

		// Change payment type on selection
		changePaymentType: async function(changeType) {
			// this.isLoading = true
			// Find if the payment type is already in state
			var matchFound = this.order.payment_method.find(paymentType => {
				return paymentType == changeType
			})

			// If match not found, add into payment type
			if (matchFound) {
				// Remove the payment type from array
				if (this.order.payment_method && this.order.payment_method.length !== 1) {
					this.order.payment_method.splice(this.order.payment_method.indexOf(changeType), 1)
				}

				// this.order = removePaymentMethod.data;
			} else {
				// Add payment type into array

				this.order.payment_method.push(changeType)
			}

			var data = {
				id: this.$store.state.orderId,
				populate_order: ['salesperson', 'coupons.brand'],
				payment_method: this.order.payment_method
			}

			var updatePaymentMethod = await this.$api.orderUpdate({
				data
			})

			this.isLoading = false

			this.order = updatePaymentMethod.data
		},

		removeCustomer: async function() {
			this.isLoading = true
			const data = {
				id: this.$store.state.orderId,
				populate_order: ['salesperson', 'coupons.brand'],
				customer: null
			}

			let updateCustomer = await this.$api.orderUpdate({
				data
			})

			if (updateCustomer) {
				this.$store.dispatch('set_customer', null)
				this.order = updateCustomer.data
			}
			this.isLoading = false
		},

		// Toggle suggestion div
		closeSuggestion: async function(value) {
			var data = {}
			// If ok button is pressed, close the div and clean the suggestion array
			if (value == 'ok') {
				// Get sale person name to display in info

				data = {
					id: this.$store.state.orderId,
					populate_order: ['salesperson', 'coupons.brand'],
					salesperson: this.selectedSalesperson
				}

				this.$swal.fire({ position: 'top-end', icon: 'success', title: 'Sales Person Added', showConfirmButton: false, timer: 1500 })

				// console.log(updateOrder);

				// this.order = updateOrder.data;
			} else if (value == 'cancel') {
				// Remove sales person into order via API

				data = {
					id: this.$store.state.orderId,
					populate_order: ['salesperson', 'coupons.brand'],
					salesperson: null
				}
			}

			var updateSalesperson = await this.$api.orderUpdate({
				data
			})

			if (updateSalesperson) {
				this.order = updateSalesperson.data
			}

			// Clean state after everything
			this.suggestions = []
			this.openSuggestions = false
			this.selectedSalesperson = null
			this.barcode = null
		},

		// Toggle suggestion div
		closeProductSuggestion: async function(value) {
			var data = {}
			// If ok button is pressed, close the div and clean the suggestion array
			if (value == 'ok') {
				// Get sale person name to display in info

				data = {
					id: this.$store.state.orderId,
					populate_order: ['salesperson', 'coupons.brand'],
					salesperson: this.selectedSalesperson
				}

				// Check if this product is already in cart
				var item = this.order.items.find(data => {
					return this.selectedProduct == data.product.barcode
				})

				var qtyToUpdate = item ? item.qty + 1 : 1

				data = {
					id: this.$store.state.orderId,
					populate_order: ['salesperson', 'coupons.brand'],
					items: [
						{
							action: 'add',
							data: {
								barcode: this.selectedProduct,
								qty: qtyToUpdate
							}
						}
					]
				}

				var updateSalesperson = await this.$api.orderUpdate({
					data
				})

				this.order = updateSalesperson.data

				// Clean state after everything
				this.productSuggestions = []
				this.openProductSuggestions = false
				this.selectedProduct = null
				this.barcode = null

				// this.order = updateOrder.data;
			} else if (value == 'cancel') {
				// Clean state after everything
				this.productSuggestions = []
				this.openProductSuggestions = false
				this.selectedProduct = null
				this.barcode = null
			}
		},

		// When user click submit in barcode reader
		submit: async function() {
			if (!this.order._id && this.backdate == true && this.orderDate == null) {
				this.$swal.fire('Please select a date')
				return
			}

			var data

			// Check if this is user or sales
			if (this.barcode.startsWith('m:')) {
				// Make sure order is active first
				if (this.$store.state.orderId == null) {
					this.$swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: 'This order is not active!'
					})

					return
				}

				// For product search
				var rawCardNumber = /[^:]*$/.exec(this.barcode)[0]

				rawCardNumber = rawCardNumber.trim()

				if (rawCardNumber !== undefined) {
					data = {
						card_number: rawCardNumber
					}

					const apiSearchMember = await this.$api.getMember({ data })

					if (!apiSearchMember || !apiSearchMember.data || apiSearchMember.data == '') {
						this.$swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: 'Invalid Member ID'
						})

						return
					} else {
						const member_id = apiSearchMember.data._id

						data = {
							id: this.$store.state.orderId,
							populate_order: ['salesperson', 'coupons.brand'],
							customer: member_id
						}

						const update_order = await this.$api.orderUpdate({
							data
						})

						this.barcode = null

						if (!update_order) {
							this.$swal.fire({
								icon: 'error',
								title: 'Oops...',
								text: 'Something went wrong with adding member'
							})

							return
						} else {
							// Save customer to vuex for information
							this.$store.dispatch('set_customer', apiSearchMember.data)
							this.$swal.fire({ position: 'top-end', icon: 'success', title: 'Member Added', showConfirmButton: false, timer: 1500 })
						}
					}
				}

				return
			} else if (this.barcode.startsWith('s:')) {
				// If user entered with s:, it is searching for sales girl name

				// Make sure order is active first
				if (this.$store.state.orderId == null) {
					this.$swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: 'This order is not active!'
					})

					return
				}

				// Get value after :
				var rawSalesName = /[^:]*$/.exec(this.barcode)[0]

				// Remove spaces if any
				var salesName = rawSalesName.trim()

				// If salesName is not blank, call API
				if (salesName) {
					const apiGetSalesperson = await this.$api.getSalesperson(salesName)

					// Check if we have result to let user select
					if (apiGetSalesperson.data.total > 0) {
						this.suggestions = apiGetSalesperson.data.list

						this.openSuggestions = true
					} else {
						this.$buefy.toast.open({
							message: 'Cannot find ' + salesName,
							type: 'is-danger',
							position: 'is-top'
						})
					}

					// console.log(apiGetSalesperson);
				}

				return
			}

			// this.isLoading = true

			// Check if there is valid order id, if not, create new order
			if (this.$store.state.orderId == null) {
				// Create new order

				var apiOrderCreate
				if (this.backdate == true) {
					const orderDate = this.$moment(this.orderDate)
						.set({ hour: 21 })
						.format('x')

					apiOrderCreate = await this.$api.orderCreate(orderDate)
				} else {
					apiOrderCreate = await this.$api.orderCreate()
				}

				// Save the order into x
				this.$store.dispatch('set_order_id', apiOrderCreate.data._id)

				this.order = apiOrderCreate.data
				// this.order.payment_method = [1];
			}

			let productDetailData = {
				barcode: this.barcode,
				qty: 1
			}

			// If this is backdate order, pass date to find promotion from that date
			if (this.order.backdate == true) {
				productDetailData.promotionDate = this.$moment(this.order.createdAt).format('x')
			}

			// Get product details with barcode
			const apiProductDetail = await this.$api.productDetail(productDetailData)

			// If product doesnt exist, display error
			if (apiProductDetail === undefined) {
				this.isLoading = false
				this.$buefy.toast.open({
					message: 'Product Not Found',
					type: 'is-danger',
					position: 'is-top'
				})
			} else {
				// Check if this product is already in cart
				var item = this.orderItems.find(data => {
					// Make sure not FOC item
					if (!data.FOC) {
						return this.barcode == data.product.barcode
					}
				})

				var qtyToUpdate = item ? item.qty + 1 : 1

				// Checking product promotions
				if (
					apiProductDetail.data.available_promotions &&
					(apiProductDetail.data.available_promotions[0].type !== 'discount_product_buy_and_get_foc_from_list' ||
						apiProductDetail.data.available_promotions[0].type == 'discount_product_buy_one_get_one_and_percentage')
				) {
					var promotions = apiProductDetail.data.available_promotions[0]._id
				}

				// Check if product has packaging options
				if (this.hasPackagingOptions(apiProductDetail.data)) {
					// Show packaging selection modal
					this.showPackagingSelection(apiProductDetail.data, item, qtyToUpdate, promotions)
					this.isLoading = false
					return
				}

				// If promotion is buy 1 get 1
				if (
					apiProductDetail.data.available_promotions &&
					(apiProductDetail.data.available_promotions[0].type == 'discount_product_buy_and_get_foc_from_list' ||
						apiProductDetail.data.available_promotions[0].type == 'discount_product_buy_one_get_one_and_percentage')
				) {
					await this.getProductFOC(apiProductDetail.data, item, qtyToUpdate)
					this.isProductPromotionActive = true
					this.isLoading = false
					this.barcode = null
					return
				}

				// Proceed with normal product addition
				await this.addProductToOrder(apiProductDetail.data, item, qtyToUpdate, promotions)
			}
			this.isLoading = false
			// Set blank barcode
			this.barcode = null
		},

		updateSpecialDiscount: async function(barcode, special_discount_percent, qty) {
			// Make sure order is still active
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				return
			}

			if (special_discount_percent < '0') {
				special_discount_percent = 0
			}

			var data = {
				id: this.$store.state.orderId,
				populate_order: ['salesperson', 'coupons.brand'],
				items: [
					{
						action: 'update',
						data: {
							barcode: barcode,
							special_discount_percent,
							qty
						}
					}
				]
			}

			// Update order ID Quantity
			const apiUpdateQty = await this.$api.orderUpdate({ data })

			if (apiUpdateQty !== undefined) {
				this.order = apiUpdateQty.data
			} else {
				this.$buefy.toast.open({
					duration: 500,
					message: 'Something went wrong!',
					type: 'is-danger',
					position: 'is-top'
				})
			}
		},

		// To display error message when order is closed
		displayErrMsg: function() {
			this.$swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'This order is not active!'
			})
		},

		// Update product quantity in cart
		updateQty: async function(barcode, qty) {
			// Make sure order is still active
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				return
			}

			// Don't accept if quantity is zero
			if (qty == '0') {
				this.$buefy.toast.open({
					duration: 500,
					message: 'Quantity cannot be zero',
					type: 'is-danger',
					position: 'is-top'
				})
				return
			}

			// Find the promotion which is added in the cart at first
			var promotions = this.orderItems.find(data => {
				if (barcode == data.product.barcode) {
					if (data.promotions.length > 0) {
						// console.log(barcode + ' has promotion');

						return true
					}
				}
			})

			// this.isLoading = true

			var data = {
				id: this.$store.state.orderId,
				populate_order: ['salesperson', 'coupons.brand'],
				items: [
					{
						action: 'update',
						data: {
							barcode: barcode,
							qty
						}
					}
				]
			}

			if (
				(promotions && promotions.promotions[0].type !== 'discount_product_buy_and_get_foc_from_list') ||
				(promotions && promotions.promotions[0].type !== 'discount_product_buy_one_get_one_and_percentage')
			) {
				// console.log('Adding ' + barcode + ' to promotions');
				data.items[0].data.promotions = [{ id: promotions.promotions[0]._id }]
			}

			// For buy 1 get 1 FOC
			if (
				(promotions && promotions.promotions[0].type == 'discount_product_buy_and_get_foc_from_list') ||
				(promotions && promotions.promotions[0].type == 'discount_product_buy_one_get_one_and_percentage')
			) {
				// console.log('Reduce the FOC Items');

				if (promotions.promotions[0].options.products.length > qty) {
					// Get differences
					const toRemove = promotions.promotions[0].options.products.length - qty

					// Remove the differences
					promotions.promotions[0].options.products.splice(0, toRemove)

					// Set ID
					data.items[0].data.promotions = [{ id: promotions.promotions[0]._id }]

					// Set options for promotion
					data.items[0].data.promotions[0].options = {}

					// Set products which is already cut
					data.items[0].data.promotions[0].options.products = promotions.promotions[0].options.products
				}
			}

			// Update order ID Quantity
			const apiUpdateQty = await this.$api.orderUpdate({ data })

			this.isLoading = false

			if (apiUpdateQty !== undefined) {
				this.order = apiUpdateQty.data
			} else {
				this.$buefy.toast.open({
					duration: 500,
					message: 'Something went wrong!',
					type: 'is-danger',
					position: 'is-top'
				})
			}
		},

		// Remove product from order
		deleteItem: async function(barcode) {
			// Make sure order is still active
			if (this.order.pay_status !== 0) {
				this.displayErrMsg()
				return
			}

			// this.isLoading = true

			var data = {
				id: this.$store.state.orderId,
				populate_order: ['salesperson', 'coupons.brand'],
				items: [
					{
						action: 'remove',
						data: {
							barcode: barcode
						}
					}
				]
			}

			// Update order ID Quantity
			const apiUpdateQty = await this.$api.orderUpdate({ data })

			this.isLoading = false

			if (apiUpdateQty !== undefined) {
				this.order = apiUpdateQty.data

				this.$buefy.toast.open({
					duration: 500,
					message: 'Item Deleted!',
					type: 'is-success',
					position: 'is-top'
				})
			} else {
				this.$buefy.toast.open({
					duration: 500,
					message: 'Something went wrong!',
					type: 'is-danger',
					position: 'is-top'
				})
			}
		},

		// When cashier click on checkout button
		checkout: async function(promotion = []) {
			console.log('Checking out...')

			this.isLoading = true
			// need to give some time for the computer to process the payment
			await new Promise(r => setTimeout(r, 1000))

			if (this.order.pay_status == 0) {
				// this.isLoading = true
				// If pay_amount is blank, set zero
				let pay_amount = this.pay_amount == null ? 0 : this.pay_amount

				var data = {
					id: this.$store.state.orderId,
					// populate_order: ['salesperson', 'coupons.brand'],
					// payment_method: this.order.payment_method,
					pay_amount,
					pay_status: 1 // Change this for test checkout
				}

				// Loop selected order promotions
				if (promotion.length > 0) {
					data.promotions = promotion
				}

				// Checkout cart
				const apiCheckout = await this.$api.orderUpdate({ data })

				// this.$set(this, 'order', apiCheckout.data);
				// this.order = await apiCheckout.data

				// Make sure it was successful
				if (apiCheckout == undefined) {
					this.$buefy.toast.open({
						duration: 500,
						message: 'Failed to checkout.',
						type: 'is-danger',
						position: 'is-top'
					})
					this.isLoading = false
				} else {
					// Make sure get Brand FOC and Order FOC in here
					let apiData = apiCheckout.data
					if (apiData.promotions && apiData.promotions.length > 0) {
						await this.getCompleteOrderPromotion(apiCheckout.data)
						await this.getTotalQtyFinal(apiCheckout.data)
						await new Promise(r => setTimeout(r, this.$config.printDelay))
					}

					this.isLoading = false
					// this.$htmlToPaper('printing');
					this.$printd.print(document.getElementById('printing'), [this.cssText])

					if (this.$store.state.doublePrint) {
						this.$swal
							.fire({
								text: 'Print Again?',
								showCancelButton: false,
								confirmButtonColor: '#3085d6',
								confirmButtonText: 'PRINT AGAIN'
							})
							.then(async result => {
								if (result.value) {
									this.$printd.print(document.getElementById('printing'), [this.cssText])

									await new Promise(r => setTimeout(r, this.$config.printDelay))

									this.cleanOrder()
								}
							})
					} else {
						await new Promise(r => setTimeout(r, this.$config.printDelay))
						this.cleanOrder()
					}
				}
			} else {
				this.isLoading = false
				this.$printd.print(document.getElementById('printing'), [this.cssText])
			}
			this.isLoading = false
		},

		cleanOrder: function() {
			// Delete the order from x
			this.$store.dispatch('set_order_id', null)
			this.$store.dispatch('set_customer', null)

			// Reset all the states
			this.barcode = null
			this.memberId = null
			this.paymentType = [1]
			this.orderDesc = null
			this.cartDetails = {}
			this.items = []
			this.selectedSalesperson = null
			this.salespersonName = null
			this.suggestions = []
			this.openSuggestions = false

			this.orderItems = []
			this.productPromotion = []

			this.orderPromotions = {}
			this.orderPromotionsAmount = {}
			this.isOrderPromotionActive = false
			this.completeOrderPromotion = []

			if (this.$store.state.orderId == null) {
				// this.order = apiOrderCreate.data;
				this.order = {}
				this.order.payment_method = [1]
			}
		},

		prepareCheckout: async function() {
			if (this.order.available_promotions) {
				// console.log('Checking available promotions');
				// Get all order promotions
				// await this.checkOrderPromotion(); // Old

				await this.prepareOrderPromotions() // New
				// Display modal
				this.isOrderPromotionActive = true
			} else {
				// If there are no order promotion, go to checkout right away
				this.checkout()
			}
		},

		prepareOrderPromotions: async function() {
			if (this.order.available_promotions) {
				this.order.available_promotions.map(available_promotion => {
					if (available_promotion.promotion_group && !this.orderPromotions[available_promotion.promotion_group.code]) {
						// this.orderPromotions[available_promotion.promotion_group.code] = [];

						this.$set(this.orderPromotions, available_promotion.promotion_group.code, [])

						var total_amount = available_promotion.order_brand_total_price ? available_promotion.order_brand_total_price : this.order.total_price

						this.$set(this.orderPromotionsAmount, available_promotion.promotion_group.code, {
							promo_code: available_promotion.promotion_group.code,
							promo_name: available_promotion.promotion_group.name,
							type: available_promotion.type,
							repeatable: available_promotion.repeatable,
							total_amount,
							promotions: []
						})
					}

					available_promotion.add_status = true

					if (available_promotion.promotion_group) {
						this.orderPromotions[available_promotion.promotion_group.code].push(available_promotion)
					}

					// const data = {
					// 	id: available_promotion._id,
					// 	status: true
					// };

					// this.orderPromotionsInfo[available_promotion.promotion_group.code].push(data);
				})

				this.getOrderPromtoionsProducts()
			}
		},

		disabledPromotion: function(type, total_amount, target, repeatable = 0) {
			if (type !== 'discount_order_buy_two_get_one' && total_amount !== undefined) {
				if (total_amount < target) {
					return 'disabled'
				}
			} else if (type == 'discount_order_buy_two_get_one' && repeatable == 0) {
				return 'disabled'
			}
		},

		disabledSpecialPromotion: function(item) {
			if (item.promotions && item.promotions.length > 0) {
				return true
			} else {
				return false
			}
		},

		addOrderPromotion: function(product, promotion_index, promo_code, target, type, repeatable = 0) {
			// console.log(this.orderPromotionsAmount);

			if (target == 0 && type == 'discount_order_buy_two_get_one') {
				if (repeatable > 0) {
					this.orderPromotionsAmount[promo_code].promotions[promotion_index].selected.push(product)

					this.orderPromotionsAmount[promo_code].repeatable--
				}
				return
			}

			if (this.orderPromotionsAmount[promo_code] && this.orderPromotionsAmount[promo_code].total_amount >= target) {
				// Add this product into selected array
				this.orderPromotionsAmount[promo_code].promotions[promotion_index].selected.push(product)

				// Deduct the brand amount based on selected promotion
				this.orderPromotionsAmount[promo_code].total_amount = this.orderPromotionsAmount[promo_code].total_amount - target
			}
		},

		removeOrderPromotion: function(type, selected_index, promotion_index, promo_code, target) {
			// console.log(promotion_index, this.orderPromotionsAmount);

			// Add this product into selected array
			this.orderPromotionsAmount[promo_code].promotions[promotion_index].selected.splice(selected_index, 1)

			if (type == 'discount_order_buy_two_get_one') {
				this.orderPromotionsAmount[promo_code].repeatable++
			} else {
				// Deduct the brand amount based on selected promotion
				this.orderPromotionsAmount[promo_code].total_amount = this.orderPromotionsAmount[promo_code].total_amount + target
			}
		},

		getOrderPromtoionsProducts: async function() {
			const thisCompo = this
			const orderPromos = thisCompo.orderPromotions
			const orderPromosAmount = thisCompo.orderPromotionsAmount

			for (const group_name in orderPromos) {
				// console.log(this.orderPromotions[promotion][0].condition);

				await Promise.all(
					orderPromos[group_name]
						.filter(promo => {
							const validTypes = [
								'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand',
								'discount_order_foc__from_product_list',
								'discount_order_buy_two_get_one'
							]

							const found = validTypes.find(type => type == promo.type)

							return found ? true : false
						})
						.map(async promotion => {
							const data = {
								id: promotion.condition.products,
								limit: 100
							}
							const {
								data: { list: productDetails }
							} = await thisCompo.$api.searchProduct({ data })

							let type = promotion.type

							if (type == 'discount_order_buy_two_get_one') {
								orderPromosAmount[group_name].promotions.push({
									id: promotion._id,
									target: 0,
									selected: [],
									type,
									repeatable: promotion.repeatable,
									products: productDetails
								})
							} else {
								orderPromosAmount[group_name].promotions.push({
									id: promotion._id,
									target: promotion.condition.target,
									selected: [],
									type,
									repeatable: 0,
									products: productDetails
								})
							}
						})
				)
			}
		},

		checkOrderPromotion: async function() {
			// Let the caisher select which product to give promotion

			await Promise.all(
				// Loop very order available promotions
				this.order.available_promotions.map(async promotion => {
					// console.log(promotion);

					var promotions = []
					promotions.promotionId = promotion._id
					promotions.products = []
					promotions.name = promotion.promotion_group.name
					promotions.repeat = promotion.repeatable
					promotions.type = promotion.type
					promotions.promotion_group_code = promotion.promotion_group.code
					promotions.target = promotion.condition.target
					promotions.enable = true

					await Promise.all(
						promotion.condition.products.map(async product => {
							// Getting product information
							// console.log('Getting Product Information');

							var data = {
								id: product
							}

							const apiGetProductDetail = await this.getProductDetail(data)

							if (apiGetProductDetail !== undefined) {
								promotions.products.push(apiGetProductDetail.data)
							}
						})
					)

					this.orderPromotionSelections.push(promotions)
				})
			)
		},

		// Get foc products
		getProductFOC: async function(products, orderItem, qty = 1) {
			// Reset product promotion selection before adding a new one
			this.productPromotionSelections = []

			// console.log(orderItem);

			await Promise.all(
				products.available_promotions[0].condition.products.map(async product => {
					var data = {
						id: product
					}

					const apiGetProductDetail = await this.getProductDetail(data)

					if (apiGetProductDetail !== undefined) {
						apiGetProductDetail.data.promotionId = products.available_promotions[0]._id
						apiGetProductDetail.data.mainProductBarcode = products.barcode
						apiGetProductDetail.data.qty = qty
						apiGetProductDetail.data.orderItem = orderItem

						this.productPromotionSelections.push(apiGetProductDetail.data)
					}
				})
			)
		},

		// Get product details
		getProductDetail: async function(data) {
			return await this.$api.getProductDetail({ data })
		},

		// Save order promotion and update
		saveOrderPromotion: function() {
			const addProduct = []

			const compo = this
			if (compo.orderPromotionsAmount && compo.orderPromotionsAmount !== undefined) {
				// const promotions = [];
				for (const promo_name in compo.orderPromotionsAmount) {
					compo.orderPromotionsAmount[promo_name].promotions.map(promotions => {
						if (promotions.selected.length > 0) {
							const newPromotion = {}
							newPromotion.id = promotions.id
							newPromotion.options = {}
							newPromotion.options.products = []

							promotions.selected.map(selected => {
								newPromotion.options.products.push(selected._id)
							})

							addProduct.push(newPromotion)
						}
					})
				}
			}

			this.checkout(addProduct)

			// this.orderPromotionsAmount.map(promotion => {
			// console.log(promotion);

			// const newPromotion = {};
			// newPromotion.id = promotion.promotionId;
			// newPromotion.options = {};
			// newPromotion.options.products = [];

			// promotion.products.map(item => {
			// 	newPromotion.options.products.push(item._id);
			// });

			// promotions.push(newPromotion);
			// });
			// data.promotions = promotions;
			// }

			// if (this.orderPromotion.length == 0) {
			// 	this.$buefy.toast.open({
			// 		message: 'At least 1 item must be selected',
			// 		type: 'is-danger',
			// 		position: 'is-top'
			// 	});
			// } else {
			// 	this.checkout();

			// 	// this.isOrderPromotionActive = false;
			// }
		},

		cancelOrderPromotion: function() {
			this.orderPromotions = {}
			this.orderPromotionsAmount = {}
			this.isOrderPromotionActive = false
			// this.orderPromotionSelections = [];
			// this.orderPromotion = [];
		},

		cancelProductPromotion: function() {
			this.isProductPromotionActive = false
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Return sorting number for display
		getItemIndex: function(index) {
			var indexNumber = index + 1

			if (indexNumber < 10) {
				return '0' + indexNumber
			} else {
				return indexNumber
			}
		}
	}
}
</script>
